import { BasicProfileData } from '@careerhub/api';
import { IAction, IActionFailed, IActionSuccess } from '../common.types';
import { User } from '@microsoft/microsoft-graph-types';

export enum UserProfileActionType {
  FETCH_MY_PROFILE_PICTURE = 'FETCH_MY_PROFILE_PICTURE',
  FETCH_MY_PROFILE_PICTURE_SUCCESS = 'FETCH_MY_PROFILE_PICTURE_SUCCESS',
  FETCH_MY_PROFILE_PICTURE_FAILED = 'FETCH_MY_PROFILE_PICTURE_FAILED',
  FETCH_MY_PROFILE_DETAILS = 'FETCH_MY_PROFILE_DETAILS',
  FETCH_MY_PROFILE_DETAILS_SUCCESS = 'FETCH_MY_PROFILE_DETAILS_SUCCESS',
  FETCH_MY_PROFILE_DETAILS_FAILED = 'FETCH_MY_PROFILE_DETAILS_FAILED',
  LOAD_MY_HR_PROFILE = 'LOAD_MY_HR_PROFILE',
  LOAD_MY_HR_PROFILE_SUCCESS = 'LOAD_MY_HR_PROFILE_SUCCESS',
  LOAD_MY_HR_PROFILE_FAILED = 'LOAD_MY_HR_PROFILE_FAILED',
}

export function loadHrProfile(): IAction {
  return {
    type: UserProfileActionType.LOAD_MY_HR_PROFILE,
  };
}

export function loadHrProfileSuccess(hrProfile: BasicProfileData): IActionSuccess<BasicProfileData> {
  return {
    type: UserProfileActionType.LOAD_MY_HR_PROFILE_SUCCESS,
    payload: hrProfile,
  };
}

export function loadHrProfileFailed(errorMessage: string): IActionFailed {
  return {
    type: UserProfileActionType.LOAD_MY_HR_PROFILE_FAILED,
    errorMessage,
  };
}

export function fetchMyProfilePicture(): IAction {
  return {
    type: UserProfileActionType.FETCH_MY_PROFILE_PICTURE,
  };
}

export function fetchMyProfilePictureSuccess(userBase64Photo: string): IActionSuccess<string> {
  return {
    type: UserProfileActionType.FETCH_MY_PROFILE_PICTURE_SUCCESS,
    payload: userBase64Photo,
  };
}

export function fetchMyProfilePictureFailed(errorMessage: string): IActionFailed {
  return {
    type: UserProfileActionType.FETCH_MY_PROFILE_PICTURE_FAILED,
    errorMessage,
  };
}

export function fetchMyProfileDetails(): IAction {
  return {
    type: UserProfileActionType.FETCH_MY_PROFILE_DETAILS,
  };
}

export function fetchMyProfileDetailsSuccess(userProfileDetails: User): IActionSuccess<User> {
  return {
    type: UserProfileActionType.FETCH_MY_PROFILE_DETAILS_SUCCESS,
    payload: userProfileDetails,
  };
}

export function fetchMyProfileDetailsFailed(errorMessage: string): IActionFailed {
  return {
    type: UserProfileActionType.FETCH_MY_PROFILE_DETAILS_FAILED,
    errorMessage,
  };
}
